<template>
    <v-card flat>
        <v-card-text>
            <v-container  grid-list-xl fluid>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-btn color="info" @click="addNewQuickBreak" v-if="$can('do','POKO_Terapeuci_Edycja') || $can('do','POKO_Terapeuci_Przerwy')" style="float:right">Dodaj szybką przerwe</v-btn>
                    </v-flex>
                    <v-flex xs12>
                        <v-data-table
                                :headers="headers"
                                :options.sync="pagination"
                                :items="items"
                                :loading="loading"
                                :server-items-length="totalResults"
                                :no-results-text="'Nie znaleziono wierszy'"
                                :footer-props="{itemsPerPageOptions:[20,50,100,200]}"
                                :no-data-text="'Brak danych'"
                        >
                            <template v-slot:item.timeStart="{item}">
                                {{ getDateFormatted(item.timeStart) }}
                            </template>
                            <template v-slot:item.timeEnd="{item}">
                                {{ getDateFormatted(item.timeEnd) }}
                            </template>
                            <template v-slot:item.id="{item}">
                                <v-layout align-center>
                                    <v-icon small @click="deleteQuickBreak(item.id)" itle="Usuń" v-if="$can('do','POKO_Terapeuci_Edycja') ||  $can('do','POKO_Terapeuci_Przerwy')">fa-trash-alt</v-icon>
                                </v-layout>
                            </template>
                        </v-data-table>
                    </v-flex>
                    <v-flex xs12>
                        <v-dialog v-model="showAddEditQuickBreak" width="640px" persistent>
                            <AddEditQuickBreak v-if="showAddEditQuickBreak" @close="closingEditor" :therapistID="therapistID"></AddEditQuickBreak>
                        </v-dialog>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    import { therapistsService } from "@/services/";
    import * as dayjs from "dayjs";
    import {mapActions} from "vuex";
    import swal from "sweetalert";
    import AddEditQuickBreak from "./AddEditQuickBreak";
    export default {
        name: "QuickBreaks",
        components: {AddEditQuickBreak},
        data() {
            return {
                loading: false,
                showAddEditQuickBreak: false,
                totalResults: 0,
                items: [],
                pagination: {},
                headers: [
                    { text: 'Początek', sortable: true, align: 'left', value: 'timeStart'},
                    { text: 'Koniec', sortable: true, align: 'left', value: 'timeEnd'},
                    { text: 'Akcje', sortable: false, align: 'left', value: 'id'}
                ],
            }
        },
        props: {
            therapistID: Number
        },
        methods: {
            ...mapActions("alert", ["error", "success"]),
            deleteQuickBreak(id) {
              swal({
                title: "Czy na pewno?",
                text:
                    "Czy na pewno chcesz usunąć tą szybką przerwe?",
                icon: "warning",
                buttons: ["Nie", "Tak"],
                dangerMode: true
              }).then(confirmed => {
                if (confirmed) {
                  therapistsService
                      .DeleteTherapistShortBreak(id)
                      .then(resp => {
                        if (resp.data == null || !resp.data.success) {
                          throw "Błąd usuwania szybkiej przerwy";
                        } else {
                          this.success("Usunięto");
                          this.refreshTable()
                        }
                      })
                      .catch(()=> {
                        this.error("Nie można usunąć szybkiej przerwy");
                      });
                }
              });
            },
            addNewQuickBreak() {
                this.showAddEditQuickBreak = true
            },
            closingEditor() {
              this.showAddEditQuickBreak = false
              this.refreshTable()
            },
            getDateFormatted(date)
            {
                if(date) {
                    var dj = dayjs(date)
                    return dj.format("DD/MM/YYYY HH:mm")
                }
                else
                {
                    return ''
                }
            },
            refreshTable()
            {
                this.loading = true

                this.requestPermits().then(data=> {
                    this.items = data.data.result.items,
                        this.totalResults = data.data.result.totalCount
                    this.loading = false
                })
            },
            requestPermits() {
                const {   page, itemsPerPage } = this.pagination
                var req = therapistsService.GetShortBreaks({ query: '', page: page, limit: itemsPerPage, therapistid: this.therapistID });
                return req.catch(() => {
                    this.showError(false,"Błąd pobierania szybkich przerw");
                });
            },
            showError(close, text) {
                swal({
                    title: "Błąd",
                    text: text,
                    icon: "warning",
                    button: "OK"
                }).then(() => {
                    this.loading = false;
                    if (close) {
                        this.$emit("close");
                    }
                });
            },
        },
        watch: {
            pagination: {
                handler() {
                    if(this.therapistID) {
                        this.refreshTable()
                    }
                },
                deep: true
            },
            therapistID: {
                immediate: true,
                handler() {
                    if(this.therapistID && this.pagination.page) {
                        this.refreshTable()
                    }
                }
            }
        },
    }
</script>

<style scoped>

</style>